// import { useContext, useEffect, useState } from "react";
// import { Box, Tab, Tabs } from "@mui/material";
// import { CustomTabPanel } from "../../../Components/CustomTabPanel";
// import { a11yProps } from "../../../Utils/TabsAllyProps";
// import CardHeader from "../../../antd/components/CardHeader";
// import LegalEntityRegistrationFinepTab from "./LegalEntityRegistrationFinepTab";
// import CompanyStageFinepTab from "./CompanyStageFinepTab";
// import ContactPhoneFinepTab from "./ContactPhoneFinepTab";
// import CompanyFinepTab from "./CompanyFinepTab";
// import AddressFinepTab from "./AddressFinepTab";
// import CapitalCompositionFinepTab from "./CapitalCompositionFinepTab";
// import { useParams } from "react-router-dom";
// import { GetCompanyFinep } from "../../../API/CompanyFinepAPI";
// import { CompanyFinepContext } from "../../../Contexts/CompanyFinepContext";
// import Loader from "../../../Components/Shared/Loader";
// import FinepPercentage from "../../../Components/Shared/FinepPercentage";
// import { CompanyFinepModel } from "../../../Models/CompanyFinepModel";
// import { CompanyFinepTabs } from "../../../Static/tabs/CompanyFinepTabs";

// const CompanyFinepTabList = () => {
//   const { companyId, id, registerId } = useParams();
//   const { company, addCompany, value, handleChangeTab, validateModel, handleFillTab, handleValidateTab, validateValue: companyValidateValue } = useContext(CompanyFinepContext);
//   const [loading, setLoading] = useState(true);

//   async function GetCompany() {
//     setLoading(true);
//     if (companyId != undefined) {
//       await GetCompanyFinep(companyId)
//         .then((response: CompanyFinepModel) => {
//           if (response) {
//             handleFillTab(0)

//             if (response.isContentValid)
//               handleValidateTab(0)
//           }
//           response.isExecutor = response.isExecutor.toString();
//           // response.foundationDate = response?.foundationDate != undefined ? response.foundationDate?.toString().split("T")[0] : response?.foundationDate;
//           // response.operationStartDate = response?.operationStartDate != undefined ? response.operationStartDate?.toString().split("T")[0] : response?.operationStartDate;

//           addCompany(response);
//         });
//     }
//     setLoading(false);
//   }

//   useEffect(() => {
//     GetCompany();
//   }, []);

//   const filleds = validateModel.reduce((acc, obj) => acc + obj.filledsPercentage, 0);

//   return (
//     <>
//       {loading && <Loader />}
//       <div className='card ml-2 mr-2'>
//         <CardHeader
//           pageName={"Finep Reembolsável - Pessoa Jurídica"}
//           pageBeforeName="Cadastro de Pessoa Física e Jurídica"
//           hasPageBefore={true}
//           linkPageBefore={`/personaCompanyFinep/${registerId}/${id}`}
//         />
//         <div className='card-body p-4'>
//           <FinepPercentage filled={Math.floor(filleds)} validated={Math.floor(companyValidateValue)} />

//           <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//             <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example">
//               {CompanyFinepTabs.map((tab, index) => {
//                 return (<Tab key={index} label={tab.label} {...tab.props} disabled={company?.id ? false : true} />)
//               })}
//             </Tabs>
//           </Box>
//           <CustomTabPanel value={value} index={0}>
//             {(company?.id || companyId == undefined) &&
//               <CompanyFinepTab
//                 company={company}
//               />
//             }
//           </CustomTabPanel>
//           <CustomTabPanel value={value} index={1}>
//             <AddressFinepTab />
//           </CustomTabPanel>
//           <CustomTabPanel value={value} index={2}>
//             <ContactPhoneFinepTab />
//           </CustomTabPanel>
//           <CustomTabPanel value={value} index={3}>
//             <LegalEntityRegistrationFinepTab />
//           </CustomTabPanel>
//           <CustomTabPanel value={value} index={4}>
//             <CapitalCompositionFinepTab />
//           </CustomTabPanel>
//           <CustomTabPanel value={value} index={5}>
//             <CompanyStageFinepTab />
//           </CustomTabPanel>
//         </div>
//       </div>
//     </>
//   );
// };

// export default CompanyFinepTabList


import { useContext, useEffect, useState } from "react";
import { Tabs, Card, Spin } from "antd";
import CardHeader from "../../../antd/components/CardHeader";
import LegalEntityRegistrationFinepTab from "./LegalEntityRegistrationFinepTab";
import CompanyStageFinepTab from "./CompanyStageFinepTab";
import ContactPhoneFinepTab from "./ContactPhoneFinepTab";
import CompanyFinepTab from "./CompanyFinepTab";
import AddressFinepTab from "./AddressFinepTab";
import CapitalCompositionFinepTab from "./CapitalCompositionFinepTab";
import { useParams } from "react-router-dom";
import { GetCompanyFinep } from "../../../API/CompanyFinepAPI";
import { CompanyFinepContext } from "../../../Contexts/CompanyFinepContext";
import Loader from "../../../Components/Shared/Loader";
import FinepPercentage from "../../../Components/Shared/FinepPercentage";
import { CompanyFinepModel } from "../../../Models/CompanyFinepModel";
import { CompanyFinepTabs } from "../../../Static/tabs/CompanyFinepTabs";

const { TabPane } = Tabs;

const CompanyFinepTabList = () => {
  const { companyId, id, registerId } = useParams();
  const { company, addCompany, value, handleChangeTab, validateModel, handleFillTab, handleValidateTab, validateValue: companyValidateValue } = useContext(CompanyFinepContext);
  const [loading, setLoading] = useState(true);

  async function GetCompany() {
    setLoading(true);
    if (companyId != undefined) {
      await GetCompanyFinep(companyId)
        .then((response: CompanyFinepModel) => {
          if (response) {
            handleFillTab(0)
            if (response.isContentValid)
              handleValidateTab(0)
          }
          response.isExecutor = response.isExecutor.toString();
          addCompany(response);
        });
    }
    setLoading(false);
  }

  useEffect(() => {
    GetCompany();
  }, []);

  const filleds = validateModel.reduce((acc, obj) => acc + obj.filledsPercentage, 0);

  return (
    <>
      {loading && <Loader />}
      <Card className="ml-2 mr-2">
        <CardHeader
          pageName={"Finep Reembolsável - Pessoa Jurídica"}
          pageBeforeName="Cadastro de Pessoa Física e Jurídica"
          hasPageBefore={true}
          linkPageBefore={`/personaCompanyFinep/${registerId}/${id}`}
        />
        <div className="p-4">
          <FinepPercentage filled={Math.floor(filleds)} validated={Math.floor(companyValidateValue)} />
          <Tabs 
            activeKey={value.toString()} 
            onChange={(activeKey) => handleChangeTab(null as any, Number(activeKey))}
          >
            {CompanyFinepTabs.map((tab, index) => (
              <TabPane
                key={index.toString()}
                tab={tab.label}
                disabled={!company?.id}
              >
                {index === 0 && (company?.id || companyId == undefined) && (
                  <CompanyFinepTab company={company} />
                )}
                {index === 1 && <AddressFinepTab />}
                {index === 2 && <ContactPhoneFinepTab />}
                {index === 3 && <LegalEntityRegistrationFinepTab />}
                {index === 4 && <CapitalCompositionFinepTab />}
                {index === 5 && <CompanyStageFinepTab />}
              </TabPane>
            ))}
          </Tabs>
        </div>
      </Card>
    </>
  );
};
export default CompanyFinepTabList;
